@if (startLoader) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
                               (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div>
    <dst-template-header (formOptionChanged)="onFormOptionChanged($event)" (consolGroupChanged)="OnConsolGroupChanged($event)">
    </dst-template-header>
    <!-- Part I  U.S. Transferor Information -->
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;Part I&nbsp;&nbsp;U.S. Transferor Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="section-content">
      <div style="margin: 15px 0 20px 71px;">
        <dst-template-leid-selector [label]="'Please specify the LEID of the Transferor'" [labelId]="'100'"
                                    (onSelectedLEChanged)="onTransferorChanged($event)" class="required-field ent-label">
        </dst-template-leid-selector>
        <div class="entity-details">
          <span style="width: 270px;">Name of Transferor:</span><span class="template-color-blue">{{!transferor ? '' : transferor.ENTITY}}</span>
        </div>
        <div class="entity-details">
          <span style="width: 270px;">Identifying number:</span><span class="template-color-blue">{{!transferor ? '' : (transferor.EIN ? transferor.EIN : 'N/A')}}</span>
        </div>
        @if (transferor && transferor.EIN === undefined) {
<div class="entity-details">
          <span class="ed-label" style="width: 270px;">EIN Missing Reason:</span>
          <div class="d-inline-block">
            <ap-dropdown [title]="'** Please select the missing reason **'" [inputAriaLabel]="'** Please select the missing reason **'" [list]="EINMissingReason" [selectType]="'single'"
                         [(ngModel)]="selectedTransferorEINItem"
                         (onSelect)="onTransferorEINMissingChange($event)" [required]="true" [hideTitleOnInput]="true">
              @for (item of EINMissingReason; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
            </ap-dropdown>
          </div>
        </div>
}
      </div>
      <ol class="main-section li-width-span-100 valign-top">
        <!-- 1 -->
        <li>
          <div class="row">
            <div class="col-md-8">
              Is the transferee a specified 10%-owned foreign corporation that is not a controlled foreign corporation?
              <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template1" [direction]="'right'" [tooltipId]="'sec926-transferee-foreign-corp'" ariaDescribedby="sec926-transferee-foreign-corp"></span>
            </div>
            <div class="col-md-4" style="padding-left: 23px;">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check1(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-1'" [(ngModel)]="transfereeForeignCorp" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check1(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-1'" [(ngModel)]="transfereeForeignCorp" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
        <!-- 2 -->
        <li>
          <span class="d-inline-block" style="padding-left: 15px;">If the transferor was a corporation, complete questions 2a through 2d.</span>
          <ol class="inner-list-alp" style="padding-left: 21px;">
            <!-- a -->
            <li>
              <div class="row">
                <div class="col-md-8">
                  If the transfer was a section 361(a) or (b) transfer, was the transferor controlled (under section
                  368(c)) by 5 or fewer domestic corporations?
                  <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template2" [direction]="'right'" [tooltipId]="'sec926-section361-transfer'" ariaDescribedby="sec926-section361-transfer"></span>
                </div>
                <div class="col-md-4">
                  <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check2a(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-2'" [(ngModel)]="Choice1a" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check2a(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-2'" [(ngModel)]="Choice1a" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <!-- b -->
            <li>
              <div class="row">
                <div class="col-md-8">
                  Did the transferor remain in existence after the transfer?
                </div>
                <div class="col-md-4">
                  <ap-radio-group [ariaLabel]="'Did the transferor remain in existence after the transfer?'">
                  <ap-radio [value]="$any(true)" (onChange)="existenceCheck(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-3'" [(ngModel)]="Choice1b" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="existenceCheck(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-3'" [(ngModel)]="Choice1b" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
                </div>
              </div>
              @if (showControllingShareHolders) {
<div class="section-content" style="padding: 0; margin-left: 36px;">
                If not, list the controlling shareholder(s) and their identifying number(s):
                <div class="row" style="padding-top: 10px;">
                  <div class="col-md-3">
                    <ap-field [title]="'Controlling shareholder'" [fieldId]="'11'" [required]="true"
                              [hideTitleOnInput]="true"
                              [styleClass]="'required-field heavy-label'">
                    <input appkit-field [(ngModel)]="controllingShareholder"  aria-label="11" />
                    </ap-field>
                  </div>
                  <div class="col-md-3">
                    <ap-field [title]="'Identifying number'" [fieldId]="'12'" [hideTitleOnInput]="true" [styleClass]="'heavy-label'">
                    <input appkit-field [(ngModel)]="identifyingNumber"  aria-label="12" />
                    </ap-field>
                  </div>
                  <div class="col-md-3">
                    <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [styleClass]="'a-mx-10 required-field-radio'" [value]="'EIN'" (onChange)="checkEINorSSN('EIN')" [name]="'radio-group-11'" [(ngModel)]="EinOrSsn" [ngModelOptions]="{standalone: true}">
                <span>EIN</span>
              </ap-radio>
                  <ap-radio [styleClass]="'a-mx-10 required-field-radio'" [value]="'SSN'" (onChange)="checkEINorSSN('SSN')" [name]="'radio-group-11'" [(ngModel)]="EinOrSsn" [ngModelOptions]="{standalone: true}">
                <span>SSN</span>
              </ap-radio>
                </ap-radio-group>
                  </div>
                </div>
                <br/>
                @if (identifyingNumber === '') {
<div style="padding-bottom: 10px;">
                  <div class="row">
                    <div class="col-md-2">
                      EIN Missing Reason:
                    </div>
                    <div class="col-md-2">
                      <ap-dropdown [list]="EINMissingReason1" [selectType]="'single'"
                                   [title]="'** Please select the missing reason **'" [inputAriaLabel]="'** Please select the missing reason **'" [(ngModel)]="selectedEINMissing1Item"
                                   (onSelect)="missingReason1($event)"
                                   class="" [hideTitleOnInput]="true">
                        @for (item of EINMissingReason1; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                          [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                      </ap-dropdown>
                    </div>
                  </div>
                </div>
}
              </div>
}
            </li>
            <!-- c -->
            <li>
              <div class="row">
                <div class="col-md-8">
                  If the transferor was a member of an affiliated group filing a consolidated return, was it the parent corporation?
                </div>
                <div class="col-md-4">
                  <ap-radio-group [ariaLabel]="'If the transferor was a member of an affiliated group filing a consolidated return, was it the parent corporation?'">
                  <ap-radio [value]="$any(true)" (onChange)="parentCoorporationCheck($event, true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-4'" [(ngModel)]="Choice1c" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="parentCoorporationCheck($event, false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-4'" [(ngModel)]="Choice1c" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
                </div>
              </div>
              @if (Choice1c === false) {
<div style="margin-left: 36px;">
                <span class="d-inline-block">
                  If not, list the name of the employer identification number (EIN) of the parent corporation:
                </span>
              </div>
}
              @if (Choice1c === false) {
<div class="section-content" style="margin-left: 21px;">
                <div class="entity-details">
                  <span style="width: 270px;">Name of Parent Corporation</span>
                  <span>{{dcnName}}</span>
                </div>
                <div class="entity-details">
                  <span style="width: 270px;">EIN of Parent Corporation</span>
                  <span class="template-color-blue">{{dcnIDNum}}</span>
                </div>
              </div>
}
            </li>
            <!-- d -->
            <li>
              <div class="row">
                <div class="col-md-8">
                  Have basis adjustments under section 367(a)(4) been made? <span
                  class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template3" [direction]="'right'"
                  [tooltipId]="'sec926-basis-adjustment'" ariaDescribedby="sec926-basis-adjustment"></span>
                </div>
                <div class="col-md-4">
                  <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check2d(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-5'" [(ngModel)]="Choice1d" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check2d(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-5'" [(ngModel)]="Choice1d" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
          </ol>
        </li>
        <!-- 3 -->
        <li>
          <span class="d-inline-block" style="padding-left: 15px;">
            If the transferor was a partner in a partnership that was the actual transferor (but is not treated as such under section 367), complete questions 3a through 3d.
          </span>
          <ol class="inner-list-alp" style="padding-left: 22px;">
            <!-- a -->
            <li class="valign-base">
              <div class="d-inline-block" style="padding-left: 15px;">
                <dst-template-leid-selector class="label-adjust" [label]="'Please specify the LEID of the Partnership'" [labelId]="'101'"
                                            (onSelectedLEChanged)="onPartnershipChanged($event)">
                </dst-template-leid-selector>
              </div>
              <div class="entity-details label-adjust" style="margin-left: 36px;">
                <span>Name of Partnership:</span><span class="template-color-blue">{{!partnership ? '' : partnership.ENTITY}}</span>
              </div>
              <div class="entity-details label-adjust" style="margin-left: 36px;">
                <span>EIN of Partnership:</span><span class="template-color-blue">{{!partnership ? '' : (partnership.EIN ? partnership.EIN : 'N/A')}}</span>
              </div>
              @if (partnership && !partnership.EIN) {
<div class="entity-details" style="margin-left: 36px !important;">
                <span style="width: 270px;">EIN Missing Reason:</span>
                <ap-dropdown class=""
                             [list]="EINMissingReason4" [selectType]="'single'" [title]="'** Please select the missing reason **'" [inputAriaLabel]="'** Please select the missing reason **'"
                             [(ngModel)]="selectedEINMissing4Item"
                             (onSelect)="missingReasonPart($event)" [hideTitleOnInput]="true">
                  @for (item of EINMissingReason4; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                </ap-dropdown>
              </div>
}
            </li>
            <br>
            <!-- b -->
            <li>
              <div class="row">
                <div class="col-md-8">
                  Did the partner pick up its pro rata share of gain on the transfer of partnership assets?
                </div>
                <div class="col-md-4">
                  <ap-radio-group [ariaLabel]="'Did the partner pick up its pro rata share of gain on the transfer of partnership assets?'">
                  <ap-radio [value]="$any(true)" (onChange)="check3b(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-6'" [(ngModel)]="Choice2b" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check3b(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-6'" [(ngModel)]="Choice2b" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <!-- c -->
            <li>
              <div class="row">
                <div class="col-md-8">
                  Is the partner disposing of its entire interest in the partnership?
                </div>
                <div class="col-md-4">
                  <ap-radio-group [ariaLabel]="'Is the partner disposing of its entire interest in the partnership?'">
                  <ap-radio [value]="$any(true)" (onChange)="check3c(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-7'" [(ngModel)]="Choice2c" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check3c(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-7'" [(ngModel)]="Choice2c" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <!-- d -->
            <li>
              <div class="row">
                <div class="col-md-8">
                  Is the partner disposing of an interest in a limited partnership that is regularly traded on an
                  established securities market?
                </div>
                <div class="col-md-4">
                  <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check3d(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-8'" [(ngModel)]="Choice2d" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check3d(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-8'" [(ngModel)]="Choice2d" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </div>
    <!-- Part II  Transferee Foreign Corporation Information -->
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;Part II&nbsp;&nbsp;Transferee Foreign Corporation Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="section-content" style="padding-bottom: 0;">
      <div class="d-flex">
        <div class="" [ngStyle]="{'width': showTransfereeManual ? '395px' : (showTransferee ? '428px': '')}">
          Is Foreign Corporation in Legal Entity Database?
        </div>
        <div class="">
          <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="checkTransferee($event)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-9'" [(ngModel)]="IsForeignCorpInGold" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [styleClass]="'a-mx-10 required-field-radio'" [value]="$any(false)" (onChange)="checkTransfereeManual($event)" [name]="'radio-group-9'" [(ngModel)]="IsForeignCorpInGold" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
        </div>
      </div>
      <!-- Transeree in Database -->
      @if (showTransferee) {
<div class="section-content" style="padding-bottom: 0;">
        <dst-template-leid-selector [label]="'Please specify the LEID of the Transferee'" [labelId]="'102'"
                                    (onSelectedLEChanged)="onTransfereeChanged($event)" class="required-field label-adjust-395">
        </dst-template-leid-selector>
        <ol class="inner-list-dec section-content-inner" style="margin-bottom: 0; padding-left: 0;counter-reset: count 3;" >
          <!-- 4 -->
          <li >
            <div class="entity-details d-inline-flex">
              <span>Name of the transferee:</span><span class="template-color-blue">{{!transferee ? '' : transferee.ENTITY}}</span>
            </div>
          </li>
          <!-- 5 -->
          <li>
            <div class="entity-details d-inline-flex">
              <span>Identifying number, if any:</span><span class="template-color-blue">{{!transferee ? '' : (transferee.EIN ? transferee.EIN : 'N/A')}}</span>
            </div>
            @if (transferee && !transferee.EIN) {
<div class="entity-details" style="margin-left: 36px !important;">
              <span>EIN Missing Reason:</span>
              <ap-dropdown class=""
                           [list]="EINMissingReason3" [selectType]="'single'" [title]="'** Please select the missing reason **'" [inputAriaLabel]="'** Please select the missing reason **'"
                           [(ngModel)]="selectedEINMissing3Item"
                           (onSelect)="missingReason3($event)" [hideTitleOnInput]="true">
                @for (item of EINMissingReason3; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
              </ap-dropdown>
            </div>
}
          </li>
          <!-- 6 -->
          <li>
            <div class="entity-details d-inline-flex">
              <span>Address Line1:</span><span class="template-color-blue">{{!transferee ? '' : transferee.ADDRESS1}}</span>
            </div>
            <div class="entity-details" style="padding-left: 21px;">
              <span>Address Line2:</span><span class="template-color-blue">{{!transferee ? '' : transferee.ADDRESS2}}</span>
            </div>
            <div class="entity-details" style="padding-left: 21px;">
              <span>City:</span><span class="template-color-blue">{{!transferee ? '' : transferee.CITY}}</span>
            </div>
            <div class="entity-details" style="padding-left: 21px;">
              <span>Province or State:</span><span class="template-color-blue">{{!transferee ? '' : stateValue}}</span>
            </div>
            <div class="entity-details" style="padding-left: 21px;">
              <span>Country:</span><span class="template-color-blue">{{!transferee ? '' : transferee.COUNTRYNAME}}</span>
            </div>
            <div class="entity-details" style="padding-left: 21px;">
              <span>Postal Code:</span><span class="template-color-blue">{{!transferee ? '' : transferee.ZIP}}</span>
            </div>
          </li>
          <!-- 7 -->
          <li>
            <div class="entity-details d-inline-flex">
              <span>Country of incorporation or organization:</span><span class="template-color-blue">{{!transferee ? '' : transferee.COUNTRYINC}}</span>
            </div>
          </li>
          <!-- 8 -->
          <li>
            <div class="entity-details d-inline-flex">
              <span>Foreign law characterization:</span><span class="template-color-blue">{{!transferee ? '' : transferee.TAXTYPE}}</span>
            </div>
          </li>
        </ol>
      </div>
}
      <!-- Transferee Not in Database -->
      @if (showTransfereeManual) {
<div>
        <ol class="inner-list-dec section-content-inner valign-top" style="margin-bottom: 0; padding-top: 15px; padding-left: 36px;counter-reset: count 3;" >
          <!-- 4 -->
          <li >
            <dst-custom-input class="required-field" [label]="'Name of transferee'" [maxLength]="150" [value]="name" (valChange)="name = $event;">
            </dst-custom-input>
          </li>
          <!-- 5 -->
          <li class="d-flex">
            <dst-custom-input id="custom-input-ein" [label]="'Identifying number, if any'" [maxLength]="9" [value]="id"
                              (valChange)="id = $event;"></dst-custom-input>
            @if (id === '') {
<div class="d-inline-flex">
              <span style="padding-right: 5px; width: 200px; text-align: end;">
                EIN Missing Reason:
              </span>
              <ap-dropdown id="ein-reason-dd-2" class="" [list]="EINMissingReason2" [selectType]="'single'"
                           [title]="'** Please select the missing reason **'" [inputAriaLabel]="'** Please select the missing reason **'"
                           [(ngModel)]="selectedEINMissing2Item"
                           (onSelect)="missingReason2($event)" [hideTitleOnInput]="true">
                @for (item of EINMissingReason2; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
              </ap-dropdown>
            </div>
}
          </li>
          <!-- 6 -->
          <li>
            <dst-custom-input class="required-field" [label]="'Address Line1'" [maxLength]="35" [value]="address1" (valChange)="address1 = $event;">
            </dst-custom-input>
            <div class="custom-input-wrapper">
              <dst-custom-input [label]="'Address Line2'" [maxLength]="35" [value]="address2" (valChange)="address2 = $event;"></dst-custom-input>
            </div>
            <div class="custom-input-wrapper">
              <dst-custom-input [label]="'City'" [maxLength]="50" [value]="city" (valChange)="city = $event;"></dst-custom-input>
            </div>
            <div class="custom-input-wrapper">
              <dst-custom-input [label]="'Province or State'" [maxLength]="50" [value]="state" (valChange)="state = $event;"></dst-custom-input>
            </div>
            <div class="d-flex custom-sd-wrapper">
              <span style="width: 330px;">Country</span>
              <ap-dropdown class="field-full-width"
                           [list]="countryDropdown1" [selectType]="'single'" [title]="'** Select Country **'" [inputAriaLabel]="'** Select Country **'" [showSearchbox]="true"
                           [(ngModel)]="selectedCountry1Item"
                           (onSelect)="selectCountry1($event)" [hideTitleOnInput]="true">
                @for (item of countryDropdown1; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Select Country **')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
              </ap-dropdown>
            </div>
            <div class="custom-input-wrapper">
              <dst-custom-input [label]="'Postal Code'" [maxLength]="50" [value]="postal" (valChange)="postal = $event;"></dst-custom-input>
            </div>
          </li>
          <!-- 7 -->
          <li>
            <div class="d-inline-flex custom-sd-wrapper" style="padding-left: 15px;">
              <span style="width: 330px;">Country of incorporation or organization</span>
              <ap-dropdown class="field-full-width"
                           [list]="countryDropdown2" [selectType]="'single'" [title]="'** Select Country **'" [inputAriaLabel]="'** Select Country **'" [showSearchbox]="true"
                           [(ngModel)]="selectedCountry2Item"
                           (onSelect)="selectCountry2($event)" [hideTitleOnInput]="true">
                @for (item of countryDropdown2; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Select Country **')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
              </ap-dropdown>
            </div>
          </li>
          <!-- 8 -->
          <li>
            <dst-custom-input class="required-field" [label]="'Foreign law characterization'" [maxLength]="35" [value]="foreign"
                              (valChange)="foreign = $event;">
            </dst-custom-input>
          </li>
        </ol>
      </div>
}
      <ol class="inner-list-dec section-content-inner" style="padding-top: 5px !important;counter-reset: count 8;" [ngStyle]="{'padding-left': showTransfereeManual ? '36px' : ''}" >
        <!-- 9 -->
        <li style=" margin-top: 0;">
          <div class="d-inline-flex">
            <div class="entity-details">
              Is the transferee foreign corporation a controlled foreign corporation?
            </div>
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check9(true)" [styleClass]="'a-mx-10 required-field-radio'" [style]="'margin-top: 4px;'" [name]="'radio-group-10'" [(ngModel)]="IsTransfereeForeignCorpCtrld" [ngModelOptions]="{standalone: true}">
              <span>Yes</span>
            </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check9(false)" [styleClass]="'a-mx-10 required-field-radio'" [style]="'margin-top: 4px;'" [name]="'radio-group-10'" [(ngModel)]="IsTransfereeForeignCorpCtrld" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </li>
      </ol>
    </div>
    <!-- Part III  Information Regarding Transfer of Property (see instructions) -->
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;Part III&nbsp;&nbsp;Information Regarding Transfer of Property (see instructions)</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <!-- Tabs -->
    <div class="tab-section section-content">
      <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'" [compact]="true"
                 (onClick)="addTab()">
        <span class="Appkit4-icon icon-plus-outline"></span> Add
      </ap-button>

      <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'"
                 [compact]="true"
                 [disabled]="tabs.length > 1 && selected.value === 0"
                 (onClick)="removeTab(selected.value)">
        <span class="Appkit4-icon icon-minus-outline"></span> Remove
      </ap-button>
      <mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="selectTab($event)" animationDuration="0">
        @for (tab of tabs; track $index; let index = $index) {
<mat-tab [label]="tab.label">
          <div class="tab-section-content pb-0">
            <ol class="inner-list-alp valign-top">
              <!--  -->
              <li class="hide-ll">
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Type of Property
                  </span>
                  <ap-dropdown [list]="tab.propertyTypeOptions" [selectType]="'single'"
                               [title]="'** Select Property Type **'" [inputAriaLabel]="'** Select Property Type **'" class="field-full-width"
                               [(ngModel)]="tab.selectedPropertyTypeItem"
                               (onSelect)="propertyTypeChange($event, index)" [hideTitleOnInput]="true">
                    @for (item of tab.propertyTypeOptions; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setAriaLabel(item, '** Select Property Type **')"
                      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                  </ap-dropdown>
                </div>
              </li>
              <!-- a -->
              <li style="counter-reset: count 0;">
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Date of transfer
                  </span>
                  <app-date-picker-with-clear
                    [minDate]="beginDate"
                    [maxDate]="endDate"
                    [datePickerClass]="'required-field'"
                    [required]="true"
                    (dateChange)="dateChange($event, index)"
                    (datePickerClick)="onDPOpen()"
                    (clearClick)="clearDate(index)"
                    [(ngModel)]="tab.dateObj">
                  </app-date-picker-with-clear>
                </div>
              </li>
              <!-- b -->
              <li style="width: calc(100% - 21px);">
                <div class="d-inline-flex" style="width: inherit;">
                  <span class="property-desc-text">
                    Description of Property
                    <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template5" [direction]="'right'" [tooltipId]="'sec926-property-description'" ariaDescribedby="sec926-property-description"></span>
                  </span>
                  <dst-custom-input class="custom-input-f1"
                                    [ngClass]="tab.propertyType && tab.propertyType !== 'cash' ? 'required-field' : ''"
                                    [type]="'textarea'" [label]="''" [maxLength]="100" [value]="tab.description"
                                    (valChange)="onValueChange($event, index, 'property')">
                  </dst-custom-input>
                </div>
              </li>
              <!-- c (type !== propdescribed367d4) -->
              @if (tab.propertyType !== 'propdescribed367d4') {
<li>
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Fair market value on date of transfer (For e-filing purposes, must be in USD)
                  </span>
                  <gtw-nullable-number-input
                    [label]="''"
                    [id]="index+'fair'"
                    class="number-field"
                    [minNum]="0"
                    [(ngModel)]="tab.fairMarketVal">
                  </gtw-nullable-number-input>
                </div>
              </li>
}
              <!-- d (type !== cash && type !== propdescribed367d4) -->
              @if (tab.propertyType !== 'cash' && tab.propertyType !== 'propdescribed367d4') {
<li>
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Cost or other basis
                  </span>
                  <gtw-nullable-number-input
                    [label]="''"
                    [id]="index+'cost'"
                    class="number-field"
                    [minNum]="0"
                    [(ngModel)]="tab.cost">
                  </gtw-nullable-number-input>
                </div>
              </li>
}
              <!-- e (type !== cash && type !== propdescribed367d4) -->
              @if (tab.propertyType !== 'cash' && tab.propertyType !== 'propdescribed367d4' && tab.propertyType !== 'lossProp') {
<li>
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Gain recognized on transfer
                  </span>
                  <gtw-nullable-number-input
                    [label]="''"
                    [id]="index+'gain'"
                    class="number-field"
                    [minNum]="0"
                    [(ngModel)]="tab.gain">
                  </gtw-nullable-number-input>
                </div>
              </li>
}
              <!-- c (type === propdescribed367d4) -->
              @if (tab.propertyType === 'propdescribed367d4') {
<li>
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Useful life
                  </span>
                  <gtw-nullable-number-input
                    [label]="''"
                    [id]="index+'useful'"
                    class="number-field"
                    [minNum]="0"
                    [(ngModel)]="tab.useful">
                  </gtw-nullable-number-input>
                </div>
              </li>
}
              <!-- d (type === propdescribed367d4) -->
              @if (tab.propertyType === 'propdescribed367d4') {
<li>
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Arm's length price on date of transfer
                  </span>
                  <gtw-nullable-number-input
                    [label]="''"
                    [id]="index+'armsLength'"
                    class="number-field"
                    [minNum]="0"
                    [(ngModel)]="tab.armLength">
                  </gtw-nullable-number-input>
                </div>
              </li>
}
              <!-- e (type === propdescribed367d4) -->
              @if (tab.propertyType === 'propdescribed367d4') {
<li>
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Cost or other basis
                  </span>
                  <gtw-nullable-number-input
                    [label]="''"
                    [id]="index+'cost'"
                    class="number-field"
                    [minNum]="0"
                    [(ngModel)]="tab.cost">
                  </gtw-nullable-number-input>
                </div>
              </li>
}
              <!-- f (type === propdescribed367d4) -->
              @if (tab.propertyType === 'propdescribed367d4') {
<li>
                <div class="d-inline-flex">
                  <span class="property-desc-text">
                    Income inclusion for year of transfer (See instructions)
                  </span>
                  <gtw-nullable-number-input
                    [label]="''"
                    [id]="index+''"
                    class="number-field"
                    [minNum]="0"
                    [(ngModel)]="tab.income">
                  </gtw-nullable-number-input>
                </div>
              </li>
}
            </ol>
          </div>
        </mat-tab>
}
      </mat-tab-group>

      <ol class="main-section section-content li-width-span-100 valign-top" style="padding-left: 36px; padding-right: 0; margin-bottom: 0;counter-reset: count 9;" >
        <!-- 10 -->
        <li class="w-100" >
          <div class="row" style="width: inherit;">
            <div class="col-md-8">
              <span>Was cash the only property transferred?</span>
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="checkSection($event)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-12'" [(ngModel)]="cashonlytransfered" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="checkSection($event)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-12'" [(ngModel)]="cashonlytransfered" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
          <div class="d-flex" style="padding-left: 35px;">
            <span>If "yes" skip the remainder of Part III and go to Part IV.</span>
          </div>
        </li>
        <!-- 11 -->
        @if (!hideSections) {
<li>
          <div class="row">
            <div class="col-md-8">
              Did the transferor transfer stock or securities subject to section 367(a) with respect to which a gain
              recognition agreement was filed?
              <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template6" [direction]="'right'" [tooltipId]="'sec926-gain-recognition'" ariaDescribedby="sec926-gain-recognition"></span>
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check11(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-13'" [(ngModel)]="transferunder367a" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check11(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-13'" [(ngModel)]="transferunder367a" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
        <!-- 12a -->
        @if (!hideSections) {
<li class="li-apdix-a">
          <div class="row">
            <div class="col-md-8">
              <span>
                Were any assets of a foreign branch (including a branch that is a foreign disregarded entity)
                transferred to a foreign corporation?
              </span>
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="checkForeign(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-14'" [(ngModel)]="foreignassets" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="checkForeign(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-14'" [(ngModel)]="foreignassets" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
          <div class="d-flex" style="padding-left: 35px;">
            <span>If "Yes," go to line 12b.</span>
          </div>
        </li>
}
        <!-- 12b -->
        @if (!hideSections && isForeignCorporation) {
<li class="li-apdix-b" style="counter-reset: count 11;">
          <div class="row">
            <div class="col-md-8">
              Was the transferor a domestic corporation that transferred substantially all of the assets of a
              foreign branch (including a branch that is a foreign disregarded entity) to a specified 10%-owned
              foreign corporation? <span class="Appkit4-icon icon-information-fill"
                                         ap-tooltip [tooltipContent]="template7" [direction]="'right'" [tooltipId]="'sec926-domestic-corp-transfer'" ariaDescribedby="sec926-domestic-corp-transfer"></span> <br/>
              If "Yes," continue to line 12c. If "No," skip lines 12c and 12d, and go to line 13.
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="checkForeign2(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-20'" [(ngModel)]="domesticcorptransfer" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="checkForeign2(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-20'" [(ngModel)]="domesticcorptransfer" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
        <!-- 12c -->
        @if (!hideSections && isForeignCorporation && isForeignCorporation2) {
<li class="li-apdix-c" style="counter-reset: count 11;">
          <div class="row">
            <div class="col-md-8">
              Immediately after the transfer, was the domestic corporation a U.S. shareholder with respect to
              the transferee foreign corporation??<br/>
              If "Yes," continue to line 12d. If "No," skip line 12d, and go to line 13.
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="checkForeign3(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-21'" [(ngModel)]="transfereeshareholder" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="checkForeign3(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-21'" [(ngModel)]="transfereeshareholder" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
        <!-- 12d -->
        @if (!hideSections && isForeignCorporation && isForeignCorporation2 && isForeignCorporation3) {
<li class="li-apdix-d" style="counter-reset: count 11;">
          <div class="row">
            <div class="col-md-8">
              Enter the transferred loss amount included in the gross income as required under section 91
            </div>
            <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
              <span class="currency-prefix">$</span>
              <gtw-nullable-number-input
                class="number-field span-match-rgroup required-field"
                [label]="''"
                [id]="'22'"
                [placeholder]="''"
                [minNum]="0"
                [(ngModel)]="transferredLoss">
              </gtw-nullable-number-input>
            </div>
          </div>
        </li>
}
        <!-- 13 -->
        @if (!hideSections) {
<li style="counter-reset: count 12;">
          <div class="row">
            <div class="col-md-8">
              Did the transferor transfer property described in section 367(d)(4)?
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Did the transferor transfer property described in section 367(d)(4)?'">
                  <ap-radio [value]="$any(true)" (onChange)="check13(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-15'" [(ngModel)]="intangiblepropsec936h" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check13(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-15'" [(ngModel)]="intangiblepropsec936h" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
        <!-- 14a -->
        @if (!hideSections) {
<li class="li-apdix-a" style="counter-reset: count 13;">
          <div class="row">
            <div class="col-md-8">
              Did the transferor transfer any intangible property that, at the time of transfer, had a useful life reasonably anticipated to exceed 20
              years?
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check14a(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-16'" [(ngModel)]="intangibleusefullife" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check14a(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-16'" [(ngModel)]="intangibleusefullife" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
        <!-- 14b -->
        @if (!hideSections) {
<li class="li-apdix-b" style="counter-reset: count 13;">
          <div class="row">
            <div class="col-md-8">
              At the time of the transfer, did any of the transferred intangible property have an indefinite useful life?
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'At the time of the transfer, did any of the transferred intangible property have an indefinite useful life?'">
                  <ap-radio [value]="$any(true)" (onChange)="check14b(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-18'" [(ngModel)]="indefiniteusefullife" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check14b(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-18'" [(ngModel)]="indefiniteusefullife" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
        <!-- 14c -->
        @if (!hideSections) {
<li class="li-apdix-c" style="counter-reset: count 13;">
          <div class="row">
            <div class="col-md-8">
              Did the transferor choose to apply the 20-year inclusion period provided under Regulations section
              1.367(d)-1(c)(3)(ii) for any intangible property?
              <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template8" [direction]="'right'" [tooltipId]="'sec926-20year-inclusion'" ariaDescribedby="sec926-20year-inclusion"></span>
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check14c(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-19'" [(ngModel)]="intangiblepropinclusion" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check14c(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-19'" [(ngModel)]="intangiblepropinclusion" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
        <!-- 14d -->
        @if (!hideSections && intangiblepropinclusion) {
<li class="li-apdix-d" style="counter-reset: count 13;">
          <div class="row">
            <div class="col-md-8">
              If the answer to line 14c is "Yes," enter the total estimated anticipated income or cost reduction attributable to the intangible
              property's or properties, as applicable, use(s) beyond the 20-year period described in Regulations section 1.367(d)-1(c)(3)(ii)
              <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template99" [direction]="'right'" [tooltipId]="'sec926-anticipated-income'" ariaDescribedby="sec926-anticipated-income"></span>
            </div>
            <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
              <span class="currency-prefix">$</span>
              <gtw-nullable-number-input
                [label]="''"
                [id]="'22'"
                [placeholder]="''"
                class="number-field span-match-rgroup required-field"
                [minNum]="0"
                [(ngModel)]="regulationAmt">
              </gtw-nullable-number-input>
            </div>
          </div>
        </li>
}
        <!-- 15 -->
        @if (!hideSections) {
<li style="counter-reset: count 14;">
          <div class="row">
            <div class="col-md-8">
              Was any intangible property transferred considered or anticipated to be, at the time of the transfer or
              at any time thereafter, a platform contribution as defined in Regulations section 1.482-7(c)(1)?
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check15(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-17'" [(ngModel)]="anticipatedtransfer" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check15(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-17'" [(ngModel)]="anticipatedtransfer" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
}
      </ol>
      <div class="list-content a-textarea-box" style="padding-left: 36px;">
        <div style="margin-bottom: 10px;">
          <span class="part3-supp-info-desc">Supplemental Part III Information Required To Be Reported (see instructions) </span>
          <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template9" [direction]="'right'" [tooltipId]="'sec926-supplemental-info'" ariaDescribedby="sec926-supplemental-info"></span>
        </div>
        <dst-custom-input class="custom-input-100" style="padding-left: 36px;"
                          [type]="'textarea'" [label]="''" [maxLength]="1000" [value]="suppInfo"
                          (valChange)="suppInfo = $event;">
        </dst-custom-input>
      </div>
    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part IV&nbsp;&nbsp;Additional Information Regarding Transfer of Property</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <ol class="main-section section-content li-width-span-100 valign-top" style="padding-left: 51px;counter-reset: count 15;" >
      <!-- 16 -->
      <li >
        <div class="row">
          <div class="col-md-12">
            Enter the transferor's interest in the foreign transferee corporation before and after the transfer:
          </div>
        </div>
        <div class="d-flex" style="padding-left: 36px;">
          <div class="d-flex" style="margin-right: 30px;">
            <span>(a) Before&nbsp;</span>
            <gtw-nullable-number-input
               [inlineBlock]="true"
               [id]="'before'"
               [minNum]="0" 
               [maxNum]="100"
               [label]="''"
               [(ngModel)]="before">
             </gtw-nullable-number-input>
            <span>&nbsp;%</span>
          </div>
          <div class="d-flex">
            <span>(b) After&nbsp;</span>
            <gtw-nullable-number-input
              [inlineBlock]="true"
              [id]="'after'"
              [minNum]="0" 
              [maxNum]="100"
              [label]="''"
              [(ngModel)]="after">
            </gtw-nullable-number-input>
            <span>&nbsp;%</span>
          </div>
        </div>
      </li>
      <!-- 17 -->
      <li>
        <div class="d-inline-flex" style="padding-left: 15px;">
          <div class="">
            <span>Type of nonrecognition transaction </span>
            <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template10" [direction]="'right'" [tooltipId]="'sec926-nonrecognition-type'" ariaDescribedby="sec926-nonrecognition-type"></span>
          </div>
          <dst-custom-input id="custom-input-trans" class="required-field" [maxLength]="20" [value]="transaction" (valChange)="transaction = $event;">
          </dst-custom-input>
        </div>
      </li>
      <!-- 18 -->
      <li>
        <span style="padding-left: 15px;">Indicate whether any transfer reported in Part III is subject to any of the following:</span>
      </li>
      <!-- 18a -->
      <li class="li-apdix-a" style="counter-reset: count 17;">
        <div class="row">
          <div class="col-md-8">
            Gain recognition under section 904(f)(3)
            <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template11" [direction]="'right'" [tooltipId]="'sec926-gain-904f3'" ariaDescribedby="sec926-gain-904f3"></span>
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check18a(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-22'" [(ngModel)]="gainunder904f3" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check18a(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-22'" [(ngModel)]="gainunder904f3" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
      </li>
      <!-- 18b -->
      <li class="li-apdix-b" style="counter-reset: count 17;">
        <div class="row">
          <div class="col-md-8">
            Gain recognition under section 904(f)(5)(F)
            <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template12" [direction]="'right'" [tooltipId]="'sec926-gain-904f5f'" ariaDescribedby="sec926-gain-904f5f"></span>
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check18b(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-23'" [(ngModel)]="gainunder904f5" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check18b(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-23'" [(ngModel)]="gainunder904f5" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
      </li>
      <!-- 18c -->
      <li class="li-apdix-c" style="counter-reset: count 17;">
        <div class="row">
          <div class="col-md-8">
            Recapture under section 1503(d)
            <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template13" [direction]="'right'" [tooltipId]="'sec926-recapture-1503d'" ariaDescribedby="sec926-recapture-1503d"></span>
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check18c(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-24'" [(ngModel)]="recapunder1503d" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check18c(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-24'" [(ngModel)]="recapunder1503d" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
      </li>
      <!-- 18d -->
      <li class="li-apdix-d" style="counter-reset: count 17;">
        <div class="row">
          <div class="col-md-8">
            Exchange gain under section 987
            <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template14" [direction]="'right'" [tooltipId]="'sec926-exchange-987'" ariaDescribedby="sec926-exchange-987"></span>
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check18d(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-25'" [(ngModel)]="exchangeunder987" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check18d(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-25'" [(ngModel)]="exchangeunder987" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
      </li>
      <!-- 19 -->
      <li>
        <div class="row">
          <div class="col-md-8">
            Did this transfer result from a change in entity classification?
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Did this transfer result from a change in entity classification?'">
                  <ap-radio [value]="$any(true)" (onChange)="check19(true)" [styleClass]="'a-mx-10'" [name]="'radio-group-26'" [(ngModel)]="forcorptransferee" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check19(false)" [styleClass]="'a-mx-10'" [name]="'radio-group-26'" [(ngModel)]="forcorptransferee" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
      </li>
      <!-- 20a -->
      <li class="li-apdix-a">
        <div class="row d-inline-flex" style="padding-left: 15px;">
          <div class="col-md-8">
            <span>Did a domestic corporation make a distribution of property covered by section 367(e)(2) (see instructions) </span>
            <span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template15" [direction]="'right'" [tooltipId]="'sec926-distribution-367e2'" ariaDescribedby="sec926-distribution-367e2"></span>
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="checkDomesticCorporation($event, 'Yes')" [styleClass]="'a-mx-10'" [name]="'radio-group-27'" [(ngModel)]="domesticcorpsec367e" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="checkDomesticCorporation($event, 'No')" [styleClass]="'a-mx-10'" [name]="'radio-group-27'" [(ngModel)]="domesticcorpsec367e" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
        <div class="row" style="padding-left: 36px;">
          <div class="col-md-12">
            If "Yes," complete lines 20b and 20c.
          </div>
        </div>
      </li>
      <!-- 20b -->
      @if (showDomesticCorporation) {
<li class="li-apdix-b" style="counter-reset: count 19;">
        <div class="row">
          <div class="col-md-8">
            Enter the total amount of gain or loss recognized pursuant to Regulations section 1.367(e)-2(b)
          </div>
          <div class="col-md-4">
            <gtw-nullable-number-input
              class="required-field number-field span-match-rgroup"
              [inlineBlock]="true"
              [id]="'amt'"
              [minNum]="0"
              [label]="''"
              [(ngModel)]="gainOrLoss">
            </gtw-nullable-number-input>
          </div>
        </div>
      </li>
}
      <!-- 20c -->
      @if (showDomesticCorporation) {
<li class="li-apdix-c" style="counter-reset: count 19;">
        <div class="row">
          <div class="col-md-8">
            Did the domestic corporation not recognize gain or loss on the distribution of property because the
            property was used in the conduct of U.S. trade of business under Regulations section 1.367(e)-2(b)(2)?
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check20c(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-28'" [(ngModel)]="propusedinustrade" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check20c(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-28'" [(ngModel)]="propusedinustrade" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
      </li>
}
      <!-- 21 -->
      <li>
        <div class="row">
          <div class="col-md-8">
            Did a domestic corporation make a section 355 distribution of stock in a foreign controlled corporation
            covered by section 367(e)(1)? See instructions
          </div>
          <div class="col-md-4">
            <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" (onChange)="check21(true)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-29'" [(ngModel)]="sec355stock" [ngModelOptions]="{standalone: true}">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" (onChange)="check21(false)" [styleClass]="'a-mx-10 required-field-radio'" [name]="'radio-group-29'" [(ngModel)]="sec355stock" [ngModelOptions]="{standalone: true}">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
          </div>
        </div>
      </li>
    </ol>
    <div class="leid-list d-flex" style="margin-top: 15px;">
      <span>LEIDs: </span>
      <div>
        @if (transferee) {
<span class="template-color-blue">{{ transferee.LEID }}</span>
}@if (transferor) {
<span> /
        </span>
}@if (transferor) {
<span class="template-color-blue">{{ transferor.LEID }}</span>
}
      </div>
    </div>
  </div>
</div>
<ng-template #template1>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      A specified 10%-owned foreign corporation is defined in section 245A(b)(1) as any foreign corporation with respect
      to which any domestic corporation is
      a U.S. shareholder. A controlled foreign corporation is defined in section 957(a) as any foreign corporation if,
      on any day during the tax year of such foreign
      corporation, U.S. shareholders own (within the meaning of section 958(a)), or are considered to own by applying
      the rules of ownership of section 958(b), more
      than 50% of (1) the total combined voting power of all classes of stock of such corporation entitled to vote, or
      (2) the total value of the stock of such
      corporation.
    </div>
  </div>
</ng-template>
<ng-template #template2>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If you answered 'Yes' to question 2a and the asset is stock, section 367(a)(4) may require basis adjustments.
      If you answered 'No' to question 2a and the asset is a tangible asset, the transfer is taxable under sections
      367(a)(1) and (a)(4).
      If the asset transferred is an intangible asset, see section 367(d) and its regulations.
    </div>
  </div>
</ng-template>
<ng-template #template3>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If the answer to line 2d is 'Yes,' and if the asset is transferred in an exchange described in section 361(a) or
      (b), attach the following.
      A statement that the conditions set forth in the second sentence of section 367(a)(4) and any regulations under
      that section have been satisfied.
      An explanation of any basis or other adjustments made pursuant to section 367(a)(4) and any regulations
      thereunder.
    </div>
  </div>
</ng-template>
<ng-template #template5>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      Provide a description of the property transferred. The description must be divided into the specified categories,
      and must include the estimated fair market value and adjusted basis of the property.
    </div>
  </div>
</ng-template>
<ng-template #template6>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If the answer to the line 11 question is 'Yes,' for any stock or securities transferred, provide a general
      description of the corporation issuing the stock or securities. See Regulations section 1.6038B-1(c)(4)(ii).
      Please report in the Supplemental Part III Information Required To Be Reported section.
    </div>
  </div>
</ng-template>
<ng-template #template7>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If the answer to lines 12b and 12c is 'Yes,' provide the following information. (1) Describe the foreign branch
      whose property is transferred. Describe the property of the foreign branch, including its adjusted basis and fair
      market value. (2) Set forth a detailed calculation of
      the transferred loss amount. Provide, on a year-by-year basis, amounts of the losses generated by such foreign
      branch after December 31, 2017, as well as any income amounts
      generated after such loss year. (3) Provide the amount, if any, recognized under section 904(f)(3) on account of
      the transfer. (4) Set forth a detailed summary of the gain
      (other than the section 91 transferred loss amount) recognized by the transferor, including any section 367(a)(1)
      gain recognized on the transfer of property. See section
      91(c). (5) Set forth a calculation of the net sum of the previously deducted losses incurred by such foreign
      branch for tax years before January 1, 2018, that would have
      been recaptured under section 367(a)(3)(C), as determined without regard to the repeal of the section 367(a)(3)
      active trade or business exception. See the transition rule
      provided by TCJA section 14102(d)(4).
    </div>
  </div>
</ng-template>
<ng-template #template8>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If the answer to the line 14c question is 'Yes,' describe the property for which the transferor
      chose to apply the 20-year inclusion period. See Regulations sections 1.6038B-1(d)(1)(iv) and 1.367(d)-1(c)
      (3)(ii). Explain how you figured the increase to the deemed payment
      rate for property transferred. See Regulations sections 1.6038B-1(d)(1) (iv) and 1.367(d)-1(c)(3)(ii). The
      explanation should include how you figured the deemed payment rate for
      each period of the useful life of the intangible property and the 20-year inclusion period.
    </div>
  </div>
</ng-template>
<ng-template #template9>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      Enter any information from Part III that is required to be reported in greater
      detail. Identify the applicable column number next to the information
      entered in this section. In addition, if you contributed property to a
      foreign corporation as part of a wider transaction, briefly describe
      the entire transaction.
    </div>
  </div>
</ng-template>
<ng-template #template10>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      List the type of nonrecognition transaction that gave rise to the reporting obligation (e.g. Section 332, 351,
      354, 356, or 361)
    </div>
  </div>
</ng-template>
<ng-template #template11>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If gain recognized was required with respect to any transfer reported in Part III under Section 904(f)(3), attach
      a statement identifying the transfer and the amount of gain recognized
    </div>
  </div>
</ng-template>
<ng-template #template12>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If gain recognized was required with respect to any transfer reported in Part III under Section 904(f)(5)(F),
      attach a statement identifying the transfer and the amount of gain recognized
    </div>
  </div>
</ng-template>
<ng-template #template13>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If recapture was required with respect to any transfer reported in Part III under Section 1503(d) dual
      consolidated loss), attach a statement identifying the transfer and the amount of the recapture. Refer to Sec.
      1503(d)
    </div>
  </div>
</ng-template>
<ng-template #template14>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If exchange gain recognition was required with respect to any transfer reported in Part III under Section 987,
      attach a statement identifying the transfer and the amount of the exchange gain recognized. Refer to Sec. 1.987-5
    </div>
  </div>
</ng-template>
<ng-template #template15>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If the answer to line 20a is 'Yes,' complete lines 20b and 20c and provide the following
      information in the Supplemental Part III Information Required To Be Reported section. Preface this supplemental
      information on the form with the heading 'Section 367(e)(2)
      Information.' A description, including the adjusted tax basis and fair market value, of all property distributed
      by the distributing corporation (regardless of whether
      the distribution of the property qualifies for nonrecognition treatment). If the answer to line 20c is 'Yes,' an
      identification of the items of property for which nonrecognition
      treatment is claimed under Regulations section 1.367(e)-2(b)(2)(ii) or (iii), as applicable.
    </div>
  </div>
</ng-template>
<ng-template #template99>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If the answer to the question on line 14c is 'Yes,' explain
      how you estimated the anticipated income or cost reduction attributable to the property's (or properties') use beyond the 20-year period.
      See Regulations section 1.6038B-1(d)(1) (iv).
    </div>
  </div>
</ng-template>
